import MainPage from 'pages/Main-Page'
import SecundaryLaguagePage from 'pages/Secundary-Language-Page'
import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

export default function routes() {

  return (
    <main>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<MainPage />}/>
          <Route path='/pt-br' element={<SecundaryLaguagePage />} />
        </Routes>
      </BrowserRouter>
    </main>
  );
}